var moment = require("moment-timezone"); moment.tz.add('Asia/Kolkata|IST|-5u|0||15e6');